import styled, { css } from 'styled-components';

import { Text } from '@/nova/components';
import { CFG_MONO_FONT } from '../../../../../../theme/configurator-tokens';
import { SPEI } from '../../spei.tokens';

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;

  & + & {
    border-top: 1px solid ${SPEI.rowDivider};
  }
`;

export const Labels = styled.div`
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled(Text)`
  font-size: 12px;
  line-height: 1;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${SPEI.rowLabel};
`;

/* The value is a bank coordinate, so it is set in a monospace face and allowed to
   wrap: an 18-digit CLABE must stay readable (and fully visible) in a narrow pane
   rather than being truncated to an ellipsis the buyer can't check against. */
export const Value = styled(Text)`
  font-family: ${CFG_MONO_FONT};
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35;
  overflow-wrap: anywhere;
  color: ${SPEI.rowValue};
`;

export const CopyButton = styled.button<{ $copied: boolean }>`
  display: flex;
  height: 36px;
  width: 36px;
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid ${SPEI.copyBorder};
  background: ${SPEI.copyBg};
  padding: 0;
  transition:
    background 150ms ease,
    border-color 150ms ease;

  &:hover {
    background: ${SPEI.copyBgHover};
  }

  ${({ $copied }) =>
    $copied &&
    css`
      border-color: ${SPEI.copiedBorder};
      background: ${SPEI.copiedBg};

      &:hover {
        background: ${SPEI.copiedBg};
      }
    `}
`;
